import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDropdownValuesAsync } from "apis/DropdownValuesApi";
import DropdownValuesResponse from "interfaces/response/DropdownValuesResponse";
import BaseState from "interfaces/state/BaseState";
import { 
  UserRoleDropdownText, 
  BillingIntervalDropdownText, 
  actionValidationDurationUnitText 
} from "../../../src/shared/constants/DropdownConstantValues";

interface DropdownValueState extends BaseState {
  userRoleValues: DropdownValuesResponse[];
  billingIntervalValues: DropdownValuesResponse[];
  actionValidationDurationUnitValues: DropdownValuesResponse[];
}

const initialState: DropdownValueState = {
  userRoleValues: [],
  billingIntervalValues: [],
  actionValidationDurationUnitValues: [],
  loading: false,
}

export const getUserRoleDropdownValues = createAsyncThunk(
  "dropdown/userRoleValues",
  async () => {
    const response = await getDropdownValuesAsync(UserRoleDropdownText);
    return response;
  }
);

export const getBillingIntervalDropdownValues = createAsyncThunk(
  "dropdown/billingIntervalDropdownValues",
  async () => {
    const response = await getDropdownValuesAsync(BillingIntervalDropdownText);
    return response;
  }
);

export const getActionValidationDurationUnitDropdownValues = createAsyncThunk(
  "dropdown/actionValidationDurationUnitDropdownValues",
  async () => {
    const response = await getDropdownValuesAsync(actionValidationDurationUnitText);
    return response;
  }
);

export const dropdownValuesSlice = createSlice({
  name: "dropdown",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUserRoleDropdownValues.pending, (state) => {
      state.userRoleValues = [];
      state.loading = true;
    });
    builder.addCase(getUserRoleDropdownValues.fulfilled, (state, action) => {
      state.loading = false;
      state.userRoleValues = action.payload;
    });
    builder.addCase(getUserRoleDropdownValues.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getBillingIntervalDropdownValues.pending, (state) => {
      state.billingIntervalValues = [];
      state.loading = true;
    });
    builder.addCase(getBillingIntervalDropdownValues.fulfilled, (state, action) => {
      state.loading = false;
      state.billingIntervalValues = action.payload;
    });
    builder.addCase(getBillingIntervalDropdownValues.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getActionValidationDurationUnitDropdownValues.pending, (state) => {
      state.actionValidationDurationUnitValues = [];
      state.loading = true;
    });
    builder.addCase(getActionValidationDurationUnitDropdownValues.fulfilled, (state, action) => {
      state.loading = false;
      state.actionValidationDurationUnitValues = action.payload;
    });
    builder.addCase(getActionValidationDurationUnitDropdownValues.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default dropdownValuesSlice.reducer;
